import { GetElevesWithQuizToNotesAndQuizQuery } from '../../../graphql/generated/graphql';
import {
  QuizWithCompetenceAndQuestions,
  UserWithQuizToNoteDef
} from '../../../types/quiz/quiz.def';

export const getClasseDefWithElevesQuizToNoteFromQuery: (
  classe: GetElevesWithQuizToNotesAndQuizQuery['classe']['data']['attributes']
) => { users: UserWithQuizToNoteDef[] } = classe => ({
  users: classe?.users?.data?.map(u => ({
    ...u?.attributes,
    quiztonotes: u?.attributes?.quiztonotes?.data?.map(qtn => ({
      ...qtn?.attributes,
      quiz: qtn?.attributes?.quiz?.data?.id
    }))
  }))
});

export const getQuizDefWithQuestionsAndCompetencesFromQuery: (
  quiz: GetElevesWithQuizToNotesAndQuizQuery['quiz']['data']['attributes']
) => QuizWithCompetenceAndQuestions = quiz => ({
  ...quiz,
  competences: quiz.competences.data.map(c => ({
    ...c.attributes
  })),
  questions: quiz.questions.data.map(q => ({
    ...q.attributes,
    id: q.id
  }))
});
